import styled from "@emotion/styled";

import { ToolBarButton } from "../buttons";

export const canvasToolbarButtonSize = 28;

export const CanvasToolbarContainer = styled.div<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $compact }) => ($compact ? "0" : "4px")};

  width: fit-content;

  background-color: ${({ theme }) => theme.surface};
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

  border-radius: ${({ theme }) => `${theme.borderRadius}px`};

  padding: ${({ $compact }) => ($compact ? "2px" : "4px")};

  cursor: default;
`;

export const CanvasToolbarButton = styled(ToolBarButton)`
  height: ${canvasToolbarButtonSize}px;
  width: ${canvasToolbarButtonSize}px;

  padding: 0;

  border: ${({ theme }) => theme.surface};
  border-radius: ${({ theme }) => `${theme.borderRadius}px`};
  background: transparent;

  &:hover {
    background-color: ${({ theme, active }) => !active && theme.surfaceVariant};
  }

  &:active {
    background-color: ${({ theme, active }) => !active && theme.surfaceBack_1};
  }

  &:disabled {
    pointer-events: all;
  }
`;

export const CanvasToolbarSeparator = styled.div`
  width: 1px;
  height: 20px;
  margin: 0 2px;

  background-color: ${({ theme }) => theme.surfaceBack_1};
`;
